import { jsx } from 'react/jsx-runtime';
import classnames from '../../node_modules/classnames/index.js';
import modules_1371da51 from './SectionThemeProvider.module.scss.js';

const SectionThemeProvider = ({ theme = "default", children, className, "data-testid": testId, }) => (jsx("div", { "data-constellation-section-theme": theme, className: classnames(className, modules_1371da51.sectionThemeProvider, {
        [modules_1371da51[`theme-${theme}`]]: theme,
    }), "data-testid": testId, children: children }));

export { SectionThemeProvider };
//# sourceMappingURL=SectionThemeProvider.js.map
